define('SageDotCom/Components/CustomerZone',[
    "jquery",
    "eventManager",
    "SageDotCom/Utility/PageModeHelper",
    "SageDotCom/Utility/sanitizer"
], function ($, eventManager, pageMode, sanitizer) {
    function CustomerZone() { }

    function scrollToAnchor(anchor) {
        var anchorTag = $(anchor);
        $("html,body").animate({ scrollTop: anchorTag.offset().top }, 750);
    }

    CustomerZone.prototype.preload = function preload() {
        if (pageMode.IsLive() || pageMode.IsPreview()) {
            //Begin - customer zone javascript to show hide panels
            //Hide panels on load.
            $(".container.customer-zone-outer .customer-zone-style-box").addClass("hidden");

            $(".container.customer-zone-outer .score-flex-box.customer-zone a[id^='customerzoneselectbutton']").each(function () {
                $(this).on("click",
                    function () {
                        var href = $(this).attr("href");

                        // Hide the default support central home panel
                        $(".score-style-box a[id='default']").parent().addClass("hidden");

                        $(".score-flex-box.customer-zone a[id^='customerzoneselectbutton'].active").each(function () {
                            $(this).toggleClass("active");
                        });

                        // Remove visibility from the default support central home panel
                        $(".score-style-box.in").each(function () {
                            $(this).addClass("hidden");
                            $(this).removeClass("in");
                        });
                        $(".customer-zone-style-box.in").each(function () {
                            $(this).addClass("hidden");
                            $(this).removeClass("in");
                        });

                        $(this).addClass("active");
                        $(".customer-zone-style-box a[id='" + href.substring(1, href.length) + "']").parent().removeClass("hidden");
                        $(".customer-zone-style-box a[id='" + href.substring(1, href.length) + "']").parent().addClass("in");

                        // Add visibility from the default panel support central home
                        $(".score-style-box a[id='" + href.substring(1, href.length) + "']").parent().removeClass("hidden");
                        $(".score-style-box a[id='" + href.substring(1, href.length) + "']").parent().addClass("in");
                    });
            });

            //OLD.
            $(".customer-zone-style-box").not(".container.customer-zone-outer .customer-zone-style-box").hide();

            //on click of "Choose different Product, hide all Product Details
            $(".customer-zone-scroll-to-top").not(".container.customer-zone-outer").on("click", function () {
                $(".highlight--customer-zone").removeClass("on");
                $(".customer-zone-style-box").hide();

                var elem = $(this);
                $("html, body")
                    .stop()
                    .animate(
                        {
                            scrollTop: $(elem.attr("href")).offset().top
                        },
                        750,
                        function () {
                            location.hash = elem.attr("href")
                                ? elem.attr("href")
                                : "";
                        }
                    );

                eventManager.trigger("select-toggled");
            });

            //On selecting a Product tile
            $(".customer-zone-lead").not(".container.customer-zone-outer").on("click", function (e) {
                $(".customer-zone-style-box").css("opacity", "1", "important");

                //remove active class from other tiles and hide all product tiles
                $(".highlight--customer-zone").removeClass("on");
                $(".customer-zone-style-box").hide();

                //add active class to the closest tile
                $(this)
                    .closest(".highlight--customer-zone")
                    .addClass("on");

                //Get the id of the Product detail style box and display it and make it scroll up
                var target = $(this).attr("href");

                $(target)
                    .closest(".customer-zone-style-box")
                    .fadeIn("slow");

                $("html, body")
                    .stop()
                    .animate(
                        {
                            scrollTop: $(target).offset().top
                        },
                        750,
                        function () {
                            location.hash = target;
                        }
                    );
            });
            //End - customer zone javascript to show hide panels
        }
    };

    CustomerZone.prototype.postload = function postload() {
        //set current customer zone selected as in the hash
        setTimeout(function () {

            var btnAnchor = sanitizer.stripHtml(window.location.hash);

            if (!sanitizer.containsHTML(unescape(btnAnchor))) {
                setTimeout(function () {
                    $(".customer-zone-lead[href='" + btnAnchor + "']").click();
                    $(".score-flex-box[href='" + btnAnchor + "']").click();

                    if ($(".score-flex-box[href='" + btnAnchor + "']").length > 0) {
                        scrollToAnchor(btnAnchor);
                    }

                }, 0);
            }
            $(".container.customer-zone-outer #supportZoneDropDown").on("change",
                function () {
                    //Get anchor tag
                    var anchor = $("#supportZoneDropDown").children("option:selected").val();

                    // Hide the default support central home panel
                    $(".score-style-box a[id='default']").parent().addClass("hidden");

                    //Handle button display for switch to desktop
                    $(".score-flex-box.customer-zone a[id^='customerzoneselectbutton'].active").each(function () {
                        $(this).toggleClass("active");
                    });

                    // Remove visibility from the default support central home panel
                    $(".score-style-box.in").each(function () {
                        $(this).addClass("hidden");
                        $(this).removeClass("in");
                    });

                    $(".customer-zone-style-box.in").each(function () {
                        $(this).addClass("hidden");
                        $(this).removeClass("in");
                    });

                    $(".score-flex-box.customer-zone a[id^='customerzoneselectbutton']").each(function () {
                        if ($(this).attr("href") === anchor) {
                            $(this).addClass("active");
                        }
                    });

                    //Display selected panel
                    $(".customer-zone-style-box a[id='" + anchor.substring(1, anchor.length) + "']").parent().addClass("in");
                    $(".customer-zone-style-box a[id='" + anchor.substring(1, anchor.length) + "']").parent().removeClass("hidden");

                    $(".score-style-box a[id='" + anchor.substring(1, anchor.length) + "']").parent().addClass("in");
                    $(".score-style-box a[id='" + anchor.substring(1, anchor.length) + "']").parent().removeClass("hidden");
                });
        });

    };

    return new CustomerZone();
});
